import moment from 'moment';

export const params = () => {
    return {
        filter: '',
        mode: 1,
        brand_id: null,
        line_id: null,
        type_id: null,
        contact_id: null,
        contact_warehouse_id: null,
        price_list_id: null,
        branch_office_id: null,
        with_existences: true,
        branch_office_warehouse_id: null,
        ultra: false
    };
};

export const params_documents = () => {
    return {
        page: 1,
        per_page: 10
    };
};

export const product = () => {
    return {
        id: null,
        code: '',
        description: null,
        percentage_sale: null,
        stock: null,
        price: 0,
        total_value: 0
    };
};

export const product_detail = () => {
    return {
        id: null,
        code: null,
        description: null,
        percentage_sale: null,
        stock: null,
        price: 0,
        total_value: 0,
        products_attachments: []
    };
};

export const document_product = () => {
    return {
        unit_value_list: null,
        document_product_id: null,
        is_benefit: null,
        quantity: null,
        original_quantity: null,
        model_id: null,
        price_list_id: null,
        percentage_discount: null,
        seller_id: null,
        promotion_id: null,
        document_id: null,
        product_id: null,
        contact_id: null,
        manage_inventory: null,
        physical_unit: null,
        unit_value_before_taxes: null,
        discount_value: 0,
        discount_value_us: 0,
        description: null,
        total_value_iva: null,
        total_value_brut: null,
        total_value_brut_us: 0,
        inventory_cost_value_unit: null,
        account_id: null,
        operationType_id: null,
        product: {}
    };
};

export const document = () => {
    return {
        contact_id: null,
        vouchertype_id: null,
        warehouse_id: null,
        model_id: null,
        consecutive: 1,
        document_date: moment().format('YYYY-MM-DD HH:mm:ss'),
        document_last_state: moment().format('YYYY-MM-DD'),
        issue_date: moment().format('YYYY-MM-DD'),
        branchoffice_id: null,
        branchoffice_warehouse_id: null,
        operationType_id: null,
        in_progress: true,
        name: null,
        documents_products: [],
        taxes: [],
        seller_id: null,
        vouchertype: {},
        observation: '',
        buy_order: '',
        general_discount: null,
        documents_information: {
            delivery_observation: ''
        }
    };
};

export const selectedPrinter = () => {
    let selected_printer = localStorage.getItem('selected_printer');

    return {
        name: selected_printer ? selected_printer : ''
    };
};

export default {
    models: [],
    all_models: [],
    product: product(),
    product_detail: product_detail(),
    data_sheets: [],
    model_form: {
        id: null,
        printing_format_point_of_sale_id: null
    },
    print_templates: [
        {id: 1, text: 'Carta'},
        {id: 2, text: 'Ticket'},
    ],
    voucher_type: null,
    model: {
        id: null,
        voucher_type: {
            code_voucher_type: null
        },
        model_prods_without_availability: {}
    },
    editing: false,
    contact: {},
    seller: {},
    price_list: {},
    lines: [],
    types: [],
    brands: [],
    products: [],
    sellers: [],
    unique_product: null,
    params: params(),
    document: document(),
    documents: {data: []},
    documents_with_dispatch_request: 0,
    document_product: document_product(),
    preloader: true,
    toggle_table: true,
    params_documents: params_documents(),
    finished_document: false,
    allow_rollback: false,
    only_view: false,
    modal_mode: {
        show: false
    },
    modal_detail: {
        show: false
    },
    modal_options: {
        show: false
    },
    url_pdf: '',
    url_pdf_two: '',
    modal_pdf: {
        show: false
    },
    modal_authorization: {
        show: false
    },
    modal_finder: {
        show: true
    },
    cancel: null,
    contact_subscriber: null,
    reverse_mode: false,
    original_document_id: null,
    modal_save_restore: {
        show: false,
        saving: true,
        id: null
    },
    edit_mode: false,
    set_back_order: true,
    uvt_control: false,
    uvt_limit_value: 0,
    printers: [],
    selected_printer: selectedPrinter(),
    subscriber: {},
    price_lists: [],
    prices: [],
    documents_by_thread: [],
    selected_document_product: document_product(),
    balance_payable: 0,
    doc_for_prods_without_avail: null,
    users: [],
    defeated_balance: 0,
    key_inventory: 'stock'
};



// WEBPACK FOOTER //
// ./src/point_of_sale/modules/point_of_sale/state.js